

































































































import dayjs from 'dayjs'
import { Component, Vue } from 'vue-property-decorator'
import controller from '@/app/ui/controllers/PublicVoucherController'
import { Utils, EventBus, EventBusConstants } from '@/app/infrastructures/misc'
import Badge from '@/app/ui/components/Badge/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import EditIcon from '@/app/ui/assets/edit_icon.vue'

@Component({
  components: {
    Badge,
    Button,
    Modal,
    EditIcon,
    LoadingOverlay,
  },
})
export default class ProgramDetail extends Vue {
  isGuest = Utils.isGuest()
  controller = controller
  confirmationModal = false
  successModal = false

  created() {
    controller.getPublicVoucherDetail(this.$route.params.id)

    EventBus.$on(EventBusConstants.DELETE_VOUCHER_SUCCESS, () => {
      this.successModal = true
    })
  }

  get voucherDetail() {
    return controller.publicVoucherDetail
  }

  get statusBadgeType() {
    if (
      this.voucherDetail?.status?.toLowerCase() === 'expired' ||
      this.voucherDetail?.status?.toLowerCase() === 'cancelled'
    ) {
      return 'error'
    } else if (
      this.voucherDetail?.status?.toLowerCase() === 'active' ||
      this.voucherDetail?.status?.toLowerCase() === 'published'
    ) {
      return 'success'
    } else {
      return 'warning'
    }
  }

  get voucherAmount() {
    return `Rp ${Utils.currencyDigit(
      this.voucherDetail?.voucherData?.pointAmount || 0
    )}`
  }

  private cancelVoucher() {
    controller.deletePublicVoucher({ publicVoucherId: this.$route.params.id })
    this.confirmationModal = false
  }

  private onCloseSuccessModal() {
    controller.getPublicVoucherDetail(this.$route.params.id)
    this.successModal = false
  }

  private formatDate(date: string, format = 'DD MMMM YYYY, HH:mm [WIB]') {
    return date ? dayjs(date).format(format) : '-'
  }

  beforeDestroy() {
    EventBus.$off(EventBusConstants.DELETE_VOUCHER_SUCCESS)
  }
}
